import React from 'react';
import DesktopGuard from '../auth/desktop/DesktopGuard';
import SearchBar from './navbarActions/search/SearchBar';
import { ChevronLeft } from 'lucide-react';
import { useRouter } from 'next/router';
const Navbar = () => {
  const router = useRouter();
  return <div className='px-4 h-[8vh] border-genius-blue border-b flex gap-4 items-center justify-between genius-shadow' data-sentry-component="Navbar" data-sentry-source-file="Navbar.tsx">
      <div className='flex items-center gap-2'>
        <div onClick={() => router.back()}>
          <div className='rounded-full w-[31px] h-[31px] text-genius-cream bg-genius-blue ta-c justify-center  flex items-center cursor-pointer'>
            <ChevronLeft className='w-[16px] h-[16px] m-0' data-sentry-element="ChevronLeft" data-sentry-source-file="Navbar.tsx" />
          </div>
        </div>
      </div>
      <div className='flex gap-1 items-center w-[870px] h-[34px] px-[12px] m-auto'>
        <SearchBar data-sentry-element="SearchBar" data-sentry-source-file="Navbar.tsx" />
      </div>
      <div className='flex items-center'>
        <DesktopGuard triggerView={false} data-sentry-element="DesktopGuard" data-sentry-source-file="Navbar.tsx"></DesktopGuard>
      </div>
    </div>;
};
export default Navbar;